import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { SignedIn, SignedOut } from '@clerk/clerk-react'
import Layout from './components/Layout'
import LandingPage from './pages/LandingPage'
import DashboardPage from './pages/DashboardPage'
import PracticePage from './pages/PracticePage'
import LearnPage from './pages/LearnPage'
import SignInPage from './pages/SignInPage'
import SignUpPage from './pages/SignUpPage'
import SettingsPage from './pages/SettingsPage'
import LiveSessionPage from './pages/LiveSessionPage'
import MemorizePage from './pages/MemorizePage'
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage'
import SubscriptionCancelPage from './pages/SubscriptionCancelPage'
import ContactPage from './pages/ContactPage'
import { isClerkEnabled } from './hooks/useClerkSafe'
import { isDev } from './data/env'

export default function App() {
  if (!isClerkEnabled) {
    return (
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/practice" element={<PracticePage />} />
          <Route path="/learn" element={<LearnPage />} />
          <Route path="/live-session" element={<LiveSessionPage />} />
          <Route path="/live-session/:sessionId" element={<LiveSessionPage />} />
          {isDev && <Route path="/memorize" element={<MemorizePage />} />}
          <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
          <Route path="/subscription/cancel" element={<SubscriptionCancelPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={
          <>
            <SignedIn><Navigate to="/dashboard" replace /></SignedIn>
            <SignedOut><LandingPage /></SignedOut>
          </>
        } />
        <Route path="/sign-in/*" element={<SignInPage />} />
        <Route path="/sign-up/*" element={<SignUpPage />} />
        <Route path="/dashboard" element={
          <>
            <SignedIn><DashboardPage /></SignedIn>
            <SignedOut><Navigate to="/sign-in" replace /></SignedOut>
          </>
        } />
        <Route path="/practice" element={
          <>
            <SignedIn><PracticePage /></SignedIn>
            <SignedOut><Navigate to="/sign-in" replace /></SignedOut>
          </>
        } />
        <Route path="/learn" element={<LearnPage />} />
        <Route path="/live-session" element={
          <>
            <SignedIn><LiveSessionPage /></SignedIn>
            <SignedOut><Navigate to="/sign-in" replace /></SignedOut>
          </>
        } />
        <Route path="/live-session/:sessionId" element={
          <>
            <SignedIn><LiveSessionPage /></SignedIn>
            <SignedOut><Navigate to="/sign-in" replace /></SignedOut>
          </>
        } />
        {isDev && (
          <Route path="/memorize" element={
            <>
              <SignedIn><MemorizePage /></SignedIn>
              <SignedOut><Navigate to="/sign-in" replace /></SignedOut>
            </>
          } />
        )}
        <Route path="/settings" element={
          <>
            <SignedIn><SettingsPage /></SignedIn>
            <SignedOut><Navigate to="/sign-in" replace /></SignedOut>
          </>
        } />
        <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
        <Route path="/subscription/cancel" element={<SubscriptionCancelPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Route>
    </Routes>
  )
}
